export enum Role {
  PowerAdmin = 'GUP.PowerAdmin',
  Admin = 'GUP.Admin',
  Guest = 'GUP.Guest',
  User = 'GUP.User',
}
